import { space } from '@synoptic/ui-kit/tokens.js';
import { style } from '@vanilla-extract/css';

export const postAuthorContainer = style({
  paddingRight: space.s24,
});
